export default __webpack_public_path__ + "static/forestwholefoods-a30913682b0ac30a3db4bdf072e9a575.jpg";